import { render, staticRenderFns } from "./SkribbleFormK.vue?vue&type=template&id=90d1eda0&scoped=true&"
import script from "./SkribbleFormK.vue?vue&type=script&lang=js&"
export * from "./SkribbleFormK.vue?vue&type=script&lang=js&"
import style0 from "./SkribbleFormK.vue?vue&type=style&index=0&id=90d1eda0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d1eda0",
  null
  
)

export default component.exports